import React, {Fragment, useRef} from "react";
import {BasicPopover} from "../../BasicPopover";
import FilterButton from "../FilterUtililties/FilterButton";
import UserInviteFilter from "./UserInviteFilter";

export default function UserInviteFilterEntry() {
    const ref = useRef();

    return(
        <Fragment>
            <BasicPopover
                ref={ref}
                id={'user-invite-filter'}
                ButtonComponent={FilterButton}>
                <UserInviteFilter handleClose={() => ref.current.close()}/>
            </BasicPopover>
        </Fragment>
    )
}